module.exports = __webpack_public_path__ + "static/media/open-sans-v15-latin-300.60c86674.woff2";